import _taggedTemplateLiteral from "/home/vsts/work/1/s/Office.Planner.Website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Flow } from '../Flow';
import { Text } from '../Text';
var StyledFormField = styled(Flow)(_templateObject());

function FormField(_a) {
  var label = _a.label,
      hint = _a.hint,
      validationMessage = _a.validationMessage,
      validationMessageStatus = _a.validationMessageStatus,
      children = _a.children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      rest = __rest(_a, ["label", "hint", "validationMessage", "validationMessageStatus", "children", "className"]);

  return _jsxs(StyledFormField, Object.assign({
    gap: "0.5rem",
    className: "formField ".concat(className)
  }, rest, {
    children: [label && _jsx(Text, Object.assign({
      small: true,
      appearance: "secondary",
      className: "formField-label",
      as: "label"
    }, {
      children: label
    }), void 0), hint && _jsx(Text, Object.assign({
      small: true,
      className: "formField-hint",
      as: "span"
    }, {
      children: hint
    }), void 0), children, validationMessage && _jsx(Text, Object.assign({
      small: true,
      className: "formField-message",
      appearance: validationMessageStatus || 'error'
    }, {
      children: validationMessage
    }), void 0)]
  }), void 0);
}

export default FormField;